import history from "history/browser";
import {useEffect} from "react";
import {useAppDispatch, useMediaGallery} from "../redux/stateHooks";
import {updateAppContext} from "../redux/slices/app";
import {Action} from "history";
import {mediaGalleryActions} from "../redux/slices/mediaGallery";
import {GALLERY_IDENTITY} from "../utils/constants";

const defaultPayload = {
    productId: window.viewModel.productId,
    primaryId: window.viewModel.primaryId
};

// This hook listens for changes to the browser history and updates the app context accordingly.
export const useHistoryListener = () => {
    const dispatch = useAppDispatch();
    const {modal: {show: showingMediaGalleryModal}} = useMediaGallery();

    // Listen for changes to the current location.
    const unlisten = history.listen(({action, location: {state, hash}}) => {
        // If the action isn't a pop, then we don't need to update the app context.
        // Both backwards and forwards navigation will trigger a pop action.
        if (action !== Action.Pop) return;

        // If the hash is not '#media-gallery' and the media gallery modal is showing, then hide it.
        if (hash.toLowerCase() !== GALLERY_IDENTITY && showingMediaGalleryModal) dispatch(mediaGalleryActions.modal.hide());

        // If the state is undefined or null, then use the default values from the view model.
        if (state === undefined || state === null) return dispatch(updateAppContext(defaultPayload));

        // Destructure the state object, defaulting to undefined if it doesn't exist.
        const {productId, primaryId} = state as { productId: undefined, primaryId: undefined };

        // If the state doesn't contain at least a productId, then use the default values from the view model.
        if (productId === undefined) return dispatch(updateAppContext(defaultPayload));

        // Update the app context with the productId and primaryId from the state.
        return dispatch(updateAppContext({productId, primaryId}));
    });

    // When the component unmounts, remove the listener.
    useEffect(() => () => unlisten(), []);
}